export default __webpack_public_path__ + "static/media/skeleton.5444edd9.gif";